import TableDeliveries from './TableDeliveries';

export default TableDeliveries;
